export default __webpack_public_path__ + "static/media/employeecard.dc35932c.png";